import FolderUploadIcon from "assets/icons/FolderUploadIcon";
import DragAndDropBase, { Format } from "../DragAndDropBase";

export interface FoldersDropBoxProps {
  title?: string;
  loading?: boolean;
  textButton?: string;
  displayFormats?: boolean;
  tooltipText?: string | JSX.Element;
  onFilesChange: (files: File[]) => void;
}

export const folderFormats: Format[] = [
  { type: "DB", formats: ["CSV"] },
  { type: "Classes", formats: ["JSON"] },
  { type: "DB_Export", formats: ["JSON"] },
  { type: "Images", formats: ["JPEG"] },
];

const FoldersDropBox = ({
  title = "Upload Folder",
  textButton = "Select Folder",
  displayFormats = true,
  loading = false,
  tooltipText,
  onFilesChange,
}: FoldersDropBoxProps) => {
  return (
    <DragAndDropBase
      directory
      title={title}
      loading={loading}
      icon={<FolderUploadIcon />}
      textButton={textButton}
      formatConfig={{ formatList: folderFormats, displayFormats }}
      tooltipText={tooltipText}
      onFilesChange={onFilesChange}
    />
  );
};

export default FoldersDropBox;
